export const USER_TYPES = {
  STATEUPDATE: "[STATUS] UPDATE"
};
